import { ContactManagementConfigContext } from '../../../../../../ui/providers';
import { DataTree } from '@juvare/common-data-table-ui/DataTree';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { LayoutColumns2 } from '@juvare/common-web-ui/LayoutColumns2';
import { ModalSlideout, ModalSlideoutContent, ModalSlideoutHeader, ModalSlideoutTitleArea, ModalSlideoutTopBar, ModalSlideoutTopBarDefaultActions, } from '@juvare/common-web-ui/ModalSlideout';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { usePublicDataClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { OrganizationTreeInfo } from './OrganizationTreeInfo';
export const OrganizationTreeWithDetailsAnonymous = (props) => {
    var _a, _b;
    const [infoSlideOutOpen, setInfoSlideOutOpen] = React.useState(false);
    const { appName } = React.useContext(ContactManagementConfigContext);
    const publicDataClient = usePublicDataClient(appName);
    const [organization, setOrganization] = React.useState();
    const theme = useTheme();
    const downSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const contentBoxRef = React.useRef();
    React.useEffect(() => {
        if (props.activeOrganizationId && props.activeOrganizationId !== 'root') {
            publicDataClient
                .publicDataGetObject(`organization-${props.activeOrganizationId}`)
                .then((response) => {
                setOrganization(response);
                setInfoSlideOutOpen(true);
                if (contentBoxRef.current) {
                    contentBoxRef.current.focus();
                }
            })
                .catch(handleErrorSnackbar);
        }
        else {
            setOrganization(undefined);
        }
    }, [props.activeOrganizationId, publicDataClient]);
    const handleCloseSlideout = () => {
        setInfoSlideOutOpen(false);
    };
    if (downSmScreen) {
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: { height: '100%', overflow: 'auto' } },
                React.createElement(DataTree, Object.assign({}, props.dataTreeProps, { border: true, filtersBar: props.filtersBar, getItemLabel: (item) => item.name, itemSelectionEnabled: props.multiSelect }))),
            React.createElement(ModalSlideout, { open: infoSlideOutOpen, onClose: handleCloseSlideout, "data-test": 'organization-details-slideout' },
                React.createElement(Box, { sx: {
                        overflow: 'auto',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: themeColors.surface.primary,
                    } },
                    React.createElement(ModalSlideoutTopBar, { isOpaque: true },
                        React.createElement(ModalSlideoutTopBarDefaultActions, { onClose: handleCloseSlideout })),
                    React.createElement(Box, null,
                        React.createElement(ModalSlideoutHeader, null,
                            React.createElement(ModalSlideoutTitleArea, { titleTypographyVariant: 'h5', title: organization === null || organization === void 0 ? void 0 : organization.name, subTitle: ((_a = organization === null || organization === void 0 ? void 0 : organization.description) === null || _a === void 0 ? void 0 : _a.html) ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: (_b = organization === null || organization === void 0 ? void 0 : organization.description) === null || _b === void 0 ? void 0 : _b.html } })) : undefined })),
                        React.createElement(ModalSlideoutContent, null,
                            React.createElement(Box, { sx: { p: 2 } },
                                React.createElement(Box, { sx: { p: 2 } }, props.activeOrganizationId && organization && (React.createElement(OrganizationTreeInfo, { id: props.activeOrganizationId, organization: organization, hideHeader: true }))))))))));
    }
    return (React.createElement(LayoutColumns2, { column1: React.createElement(Box, { sx: (theme) => ({ height: '100%', borderRight: '1px solid ' + theme.palette.divider }) },
            React.createElement(DataTree, Object.assign({}, props.dataTreeProps, { border: true, filtersBar: props.filtersBar, getItemLabel: (item) => item.name, itemSelectionEnabled: props.multiSelect }))), column2: React.createElement(Box, { sx: { p: 2, height: '100%', width: '600px' }, tabIndex: 0, ref: contentBoxRef }, props.activeOrganizationId && organization && (React.createElement(OrganizationTreeInfo, { id: props.activeOrganizationId, organization: organization }))), fullWidthColumn: 'column1', column2Scrollable: true, column1Scrollable: true }));
};
